import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import _objectSpread from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/createClass";
// client js begin
import Boss from '@tencent/vft-common/Boss';
import LJReport from '@tencent/vft-speedreport/LJReport'; // client js end

var boss = null;
var monitor = null;

var Report = /*#__PURE__*/function () {
  function Report(performanceReportData) {
    _classCallCheck(this, Report);

    // 上报初始化
    boss = boss || new Boss({
      bossId: 6183,
      pwd: 1714812455
    });
    monitor = monitor || new LJReport({
      project: 'video_vip_fe',
      page: 'cloud_seal_card'
    });
    this.performanceReportData = performanceReportData || {};
  }

  _createClass(Report, [{
    key: "setReportData",
    value: function setReportData(key, val) {
      this.performanceReportData[key] = val;
    }
  }, {
    key: "reportImgLoad",
    value: function reportImgLoad() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          tryCount = _ref.tryCount,
          cost = _ref.cost;

      var oldTryCount = this.performanceReportData.imgLoadTryCount || 0;
      var oldCost = this.performanceReportData.imgLoadCost || 0;
      this.setReportData('imgLoadTryCount', oldTryCount + tryCount);
      this.setReportData('imgLoadCost', oldCost + cost);
    }
  }, {
    key: "reportPerformance",
    value: function reportPerformance() {
      try {
        var _this$performanceRepo = this.performanceReportData,
            _this$performanceRepo2 = _this$performanceRepo.totalCost,
            totalCost = _this$performanceRepo2 === void 0 ? 0 : _this$performanceRepo2,
            _this$performanceRepo3 = _this$performanceRepo.replaceCost,
            replaceCost = _this$performanceRepo3 === void 0 ? 0 : _this$performanceRepo3,
            _this$performanceRepo4 = _this$performanceRepo.showImgCost,
            showImgCost = _this$performanceRepo4 === void 0 ? 0 : _this$performanceRepo4,
            _this$performanceRepo5 = _this$performanceRepo.fetchDataError,
            fetchDataError = _this$performanceRepo5 === void 0 ? 0 : _this$performanceRepo5,
            _this$performanceRepo6 = _this$performanceRepo.showImgError,
            showImgError = _this$performanceRepo6 === void 0 ? 0 : _this$performanceRepo6,
            _this$performanceRepo7 = _this$performanceRepo.backData,
            backData = _this$performanceRepo7 === void 0 ? 0 : _this$performanceRepo7,
            _this$performanceRepo8 = _this$performanceRepo.imgLoadError,
            imgLoadError = _this$performanceRepo8 === void 0 ? 0 : _this$performanceRepo8,
            _this$performanceRepo9 = _this$performanceRepo.picGeneratorFailHandler,
            picGeneratorFailHandler = _this$performanceRepo9 === void 0 ? 0 : _this$performanceRepo9,
            mode = _this$performanceRepo.mode,
            id = _this$performanceRepo.id,
            version = _this$performanceRepo.version;
        monitor.report({
          modId: 'card',
          metrics: _objectSpread(_objectSpread({}, this.performanceReportData), {}, {
            totalCost: totalCost,
            replaceCost: replaceCost,
            showImgCost: showImgCost,
            showImgError: showImgError,
            backData: backData,
            imgLoadError: imgLoadError,
            picGeneratorFailHandler: picGeneratorFailHandler,
            count: 1,
            error: fetchDataError || showImgError || picGeneratorFailHandler
          }),
          tags: {
            version: version,
            mode: mode,
            id: id,
            href: location.href.split('?')[0]
          }
        });
      } catch (e) {}
    }
  }, {
    key: "reportLog",
    value: function reportLog(module, log) {
      this.performanceReportData[module] = 1;
      boss.report({
        f_url: '/cloud_seal_card',
        f_resource: location.pathname,
        f_dm: location.host,
        f_module: module,
        f_ext: log,
        _dc: Math.random()
      });
    }
  }]);

  return Report;
}();

export { Report as default };